package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_NOTIFICATION_SETTINGS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateNotificationSettingsRequestModel(
    val userId: Long = 0,
    val reservationCompletedPushEnabled: Boolean = true,
    val reservationCompletedEmailEnabled: Boolean = false,
    val discountsAndNewsPushEnabled: Boolean = true,
    val discountsAndNewsEmailEnabled: Boolean = false
) : BaseRequestModel(api = UPDATE_NOTIFICATION_SETTINGS)
